
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/[destinationSlug]/[hotelSlug]/[unitGroupSlug]",
      function () {
        return require("private-next-pages/destinations/[destinationSlug]/[hotelSlug]/[unitGroupSlug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/[destinationSlug]/[hotelSlug]/[unitGroupSlug]"])
      });
    }
  